import React, { useEffect, useRef, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import clsx from 'clsx';

import styles from './styles';
import { useEnumContext } from "../../../services/EnumService";
import Equations from "../../Equations";
import SampleSolutionPlot from '../SampleSolutionPlot';

const SolutionCard = (props) => {
    const {
        classes,
        solution,
        clickHandle,
        showStatus,
        showEquation: showEquationProp,
        plotWidth: plotWidthProp,
        plotHeight: plotHeightProp,
    } = props;

    const defaultShowEquation = showEquationProp ?? true;
    const plotWidth = plotWidthProp ?? 350;
    const plotHeight = plotHeightProp ?? 170;

    const enums = useEnumContext();

    // Component States
    const [displayEquation, setDisplayEquation] = useState(defaultShowEquation);

    // Setup Component
    useEffect(() => {
        setDisplayEquation(showEquationProp ?? true);
    }, [showEquationProp]);

    if (!enums) {
        return null;
    }

    const getEquationTypeIcon = () => {
        if (solution.equation_type == "ode") {
            return <Icon fontSize="small" className={classes.cardSubHeaderIcon}>show_chart</Icon>
        } else {
            return <Icon fontSize="small" className={classes.cardSubHeaderIcon}>legend_toggle</Icon>
        }
    }
    const getConditions = () => {
        let conditions = solution.diff_equation_details.conditions;

    }
    const getConditionDomain = (condition) => {
        let condition_str = "";
        if (condition.condition_type == "IVP") {
            condition_str = "(" + condition.t_0 + "," + condition.u_0 + ")";
        }
        if (condition.condition_type == "DirichletBVP2D") {
            condition_str = "(" + condition.x0 + "," + condition.x1 + ")" + " - (" + condition.y0 + "," + condition.y1 + ")";
        }

        return condition_str;
    }
    const getEquationTypeAvatar = () => {
        if (solution.equation_type == "ode") {
            return <Avatar variant="square" className={classes.cardHeaderAvatar}>ODE</Avatar>
        } else {
            return <Avatar variant="square" className={classes.cardHeaderAvatar}>PDE</Avatar>
        }
    }
    const getStatusIcon = () => {
        if (!showStatus) {
            return null;
        }

        if (solution["hub_status"] === "published") {
            return <Icon className={clsx(classes.statusIcon, classes.statusPublished)}>public</Icon>;
        }
        if (solution["hub_status"] === "submitted") {
            return <Icon className={clsx(classes.statusIcon, classes.statusSubmitted)}>vpn_lock</Icon>;
        }
        if (solution["hub_status"] === "rejected") {
            return <Icon className={clsx(classes.statusIcon, classes.statusRejected)}>block</Icon>;
        }
        return <Icon className={clsx(classes.statusIcon, classes.statusDraft)}>vpn_lock</Icon>;
    }
    const plotIconClass = clsx(classes.mediaSwitchIcon, !displayEquation && classes.mediaSwitchIconActive);
    const equationIconClass = clsx(classes.mediaSwitchIcon, displayEquation && classes.mediaSwitchIconActive);
    const plotTextClass = clsx(classes.mediaSwitchText, !displayEquation && classes.mediaSwitchTextActive);
    const equationTextClass = clsx(classes.mediaSwitchText, displayEquation && classes.mediaSwitchTextActive);

    return (
        <Card>
            <CardContent
                className={classes.cardHeader}
            >
                <div style={{ "display": "flex" }}>
                    {getEquationTypeAvatar()}
                    <Typography
                        variant="h6"
                        onClick={() => clickHandle(solution)}
                    >
                        {solution.equation_name ? solution.equation_name : solution.name}
                    </Typography>
                    <div className={classes.grow} onClick={() => clickHandle(solution)} />
                    <div className={classes.mediaSwitch}>
                        <Icon className={plotIconClass} onClick={() => setDisplayEquation(false)}>insights</Icon>
                        <Typography className={plotTextClass} component="span" align="justify" onClick={() => setDisplayEquation(false)}>
                            &nbsp;Sample Solution
                        </Typography>
                        <Icon className={equationIconClass} onClick={() => setDisplayEquation(true)}>functions</Icon>
                        <Typography className={equationTextClass} component="span" align="justify" onClick={() => setDisplayEquation(true)}>
                            &nbsp;Equation
                        </Typography>
                    </div>
                    {getStatusIcon()}
                </div>
                {(solution.owner_email || solution.owner_username) && (
                    <Typography className={classes.ownerText} component="div">
                        {solution.owner_username || solution.owner_email}
                        {solution.owner_email && solution.owner_username ? ` — ${solution.owner_email}` : ''}
                    </Typography>
                )}
            </CardContent>
            <CardContent
                className={classes.cardSubHeader}
            >
                <div style={{ "display": "flex" }}>
                    {solution.diff_equation_details.conditions && solution.diff_equation_details.conditions.map((con, index) =>
                        <div className={classes.badge}>
                            <span className={classes.cardSubHeaderText}>
                                {enums["condition_types"][enums["condition_type_mapping"][con.condition_type]]}
                                &nbsp;
                                {getConditionDomain(con)}
                            </span>
                        </div>
                    )}


                    <div className={classes.grow} />
                </div>
            </CardContent>
            <CardMedia onClick={() => clickHandle(solution)} className={classes.cardMedia}>
                {displayEquation &&
                    <Equations key={solution.id} solution={solution}></Equations>
                }
                {!displayEquation &&
                    <SampleSolutionPlot solution={solution} width={plotWidth} height={plotHeight}></SampleSolutionPlot>
                }
            </CardMedia>
            <CardActions disableSpacing>
                <Icon className={classes.labelIcon}>label</Icon>
                <Typography color="textSecondary" className={classes.labelText}>
                    &nbsp;{solution.label}
                </Typography>
                <div className={classes.grow} />
                <Icon className={classes.likeIcon}>thumb_up</Icon>
                <div className={classes.likeText}>
                    {solution.like_count}
                </div>
                <Icon className={classes.downloadIcon}>download</Icon>
                <div className={classes.downloadText}>
                    {solution.download_count}
                </div>
            </CardActions>
        </Card >
    );
};

export default withStyles(styles)(SolutionCard);
